import { render, staticRenderFns } from "./TeamMemberCard.vue?vue&type=template&id=b5f69fd4"
import script from "./TeamMemberCard.vue?vue&type=script&lang=js"
export * from "./TeamMemberCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports